import React, { useContext, useState } from "react";
import ReactModal from "react-modal";
import { useLocation } from "react-router-dom";
import DownloadPdfBtn from "../../components/DownloadPdfBtn";
import Header from "../../components/Header";
import { questions } from "../../utils/constants";
import SurveyDtlsItem from "./components/SurveyDtlsItem";
import SurveyRadarChart from "./components/SurveyRadarChart";
import generatePDF, { Resolution, Margin } from "react-to-pdf";
import { ddmmyyyy } from "../../helpers/ddmmyyyy";
import {
  collection,
  query,
  getDocs,
  deleteDoc,
  doc,
  where,
  orderBy
} from "firebase/firestore";
import { auth, db } from "../../utitilties/firebase";

const SurveyDetails = () => {
  const { survey, therapist } = useLocation().state;

  const [showChart, setShowChart] = useState(false);
  const [user, setUser] = useState();

  const getUser = async () => {
    const q = query(
      collection(db, "PhysioCenters"),
      where("email", "==", auth.currentUser.email)
    );
    const querySnapshot = await getDocs(q);
    let tempUser = "";
    querySnapshot.forEach((doc) => {
      tempUser = { id: doc.id, ...doc.data() };
    });
    setUser(tempUser);
  };
  console.log(user, "uuuu");
  const downloadPdf = () => {
    const options = {
      method: "open",
      // default is Resolution.MEDIUM = 3, which should be enough, higher values
      // increases the image quality but also the size of the PDF, so be careful
      // using values higher than 10 when having multiple pages generated, it
      // might cause the page to crash or hang.
      resolution: Resolution.NORMAL,
      page: {
        // margin is in MM, default is Margin.NONE = 0
        margin: Margin.SMALL,
        // default is 'A4'
        // format: "letter",
        // default is 'portrait'
        // orientation: "landscape"
      },
      canvas: {
        // default is 'image/jpeg' for better size performance
        mimeType: "image/png",
        qualityRatio: 1
      },
      // Customize any value passed to the jsPDF instance and html2canvas
      // function. You probably will not need this and things can break,
      // so use with caution.
      overrides: {
        // see https://artskydj.github.io/jsPDF/docs/jsPDF.html for more options
        pdf: {
          compress: true
        },
        // see https://html2canvas.hertzen.com/configuration for more options
        canvas: {
          useCORS: true
        }
      }
    };
    const getTargetElement = () => document.getElementById("pdf");
    generatePDF(getTargetElement, options);
  };
  useState(() => {
    getUser();
  }, []);
  return (
    <div style={{ padding: 50 }}>
      <Header
        label={""}
        right={
          <div style={{ display: "flex", alignItems: "center" }}>
            {/* <DownloadPdfBtn downloadFileName={'Survey'} rootElementId='pdf'answers={survey.answers} center={therapist} clientName={survey.userName} /> */}
            <div
              onClick={downloadPdf}
              className="btn "
              style={{ marginRight: 10 }}
            >
              Download
            </div>
            <p
              onClick={() => setShowChart(true)}
              style={{
                marginLeft: "auto",
                cursor: "pointer",
                color: "blue",
                textDecorationLine: "underline"
              }}
            >
              Show Chart
            </p>
          </div>
        }
      />
      <div id="pdf">
        <p style={{ fontSize: 32, fontWeight: "bold" }}>Survey </p>
        <div
          style={{
            marginTop: 10,
            // display: "flex",
            // justifyContent: "space-between"
          }}
        >
          <div>
            <p style={{ fontSize: 20 }}>{survey.userName}</p>
            <p style={{ marginTop: 5, color: "gray" }}>
              {ddmmyyyy(new Date(survey?.timestamp.seconds * 1000))}
            </p>
          </div>
          {/* <div style={{width:'55%'}} /> */}

          <div
            style={{
              width:250,
              display: "flex",
              flexDirection: "column",
              alignItems: "center"
            }}
          >
            <p style={{ marginTop: 10, fontSize: 20 }}>{user?.name}</p>
            <img
              src={user?.logo}
              alt="logo"
              style={{ width: 100, height: 100, objectFit: "contain" }}
            />
            <p style={{ marginTop: 10, fontSize: 18, color: "gray" }}>
              Therapist: {therapist.name}
            </p>
          </div>
        </div>
        <div style={{ display: "flex",flexDirection:'row' ,}}>
          <div style={{ marginTop: 0,paddingRight:10 }}>
            {questions.map((qstn, id) => (
              <SurveyDtlsItem id={id} survey={survey} question={qstn} />
            ))}
          </div>
        <div style={{ padding:10, width:'100%',display:'flex',justifyContent:'center',}} >
        <SurveyRadarChart  survey={survey} modal={false} />
        </div>
        
        </div>
      </div>

      <ReactModal
        isOpen={showChart}
        onRequestClose={() => setShowChart(null)}
        style={{
          content: {
            top: "50%",
            left: "20%",
            right: "auto",
            bottom: "auto",
            transform: "translate(-0%, -50%)",
            width: "60%",
            height: "90vh"
          },
          overlay: {
            background: "#DCDCDC80"
          }
        }}
        contentLabel="Example Modal"
      >
        <SurveyRadarChart
          modal={true}
          onClose={() => setShowChart(null)}
          survey={survey}
        />
      </ReactModal>
    </div>
  );
};

export default SurveyDetails;
